export default "__VITE_ASSET__d62a6253__"